<emma-rich-editor-insert-image-tag-modal
    *ngIf="insertImageTagModal"
    (close)="insertImageTagModal = false"
    ($insert)="onInsertImageTag($event)"
></emma-rich-editor-insert-image-tag-modal>
<emma-text-check-modal
    *ngIf="showCheckModal"
    [items]="autocompleteItems"
    [type]="autocompleteCheckItemsModalType"
    [text]="value"
    (close)="onCancelCheckItems()"
    [icon]="autocompleteCheckIcon"
>
</emma-text-check-modal>
<div [ngClass]="_containerClass">
    <quill-editor
        [(ngModel)]="value"
        [required]="!!required"
        [readOnly]="readonly || disabled"
        [format]="format"
        [sanitize]="sanitize"
        [placeholder]="placeholder"
        [minLength]="minlength"
        [maxLength]="maxlength"
        (onBlur)="onBlur()"
        (onContentChanged)="onContentChanged($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
    >
        <div quill-editor-toolbar>
            <span class="ql-formats">
                <button emmaButton class="ql-bold"></button>
                <button emmaButton class="ql-italic"></button>
                <button emmaButton class="ql-underline"></button>
                <button emmaButton class="ql-strike"></button>
            </span>
            <span class="ql-formats">
                <select class="ql-color"></select>
                <select class="ql-background"></select>
            </span>
            <span class="ql-formats">
                <button emmaButton class="ql-script" value="sub"></button>
                <button emmaButton class="ql-script" value="super"></button>
            </span>
            <span class="ql-formats">
                <button emmaButton class="ql-list" value="ordered"></button>
                <button emmaButton class="ql-list" value="bullet"></button>
            </span>
            <span class="ql-formats">
                <button emmaButton class="ql-link"></button>
            </span>
            <span class="ql-formats">
                <button emmaButton class="ql-clean"></button>
            </span>
            <span class="ql-formats">
                <button emmaButton [hasIcon]="true" (click)="insertImageTagModal = true">
                    <i class="la la-image" aria-hidden="true"></i>
                </button>
            </span>
            <span *ngIf="autocompleteItems.length" class="ql-formats ql-custom">
                <button
                    class="emma-textarea--autocomplete-checker"
                    emmaButton
                    sizeButton="sm"
                    [isCircle]="true"
                    [noBg]="true"
                    [hasIcon]="true"
                    [onlyIcon]="true"
                    (click)="onCheckItems()"
                    [ngbPopover]="autocompleteCheckPopoverMsg"
                    placement="top"
                    triggers="hover"
                    container="body"
                    i18n-ngbPopover
                >
                    <i class="la {{ autocompleteCheckIcon }}" aria-hidden="true"></i>
                </button>
            </span>
            <span *ngIf="autocompleteItems.length" class="ql-formats ql-custom">
                <emma-dropdown
                    class="emma-rich-editor--autocomplete-dropdown"
                    color="link-emmadarkblue"
                    [items]="autocompleteItems"
                    [buttonLabel]="autocompleteButtonLabel"
                    [buttonIcon]="autocompleteButtonIcon"
                    [groupBy]="autocompleteGroupBy"
                    [searchable]="true"
                    [disabled]="disabled"
                    ($select)="onSelectAutocompleteTag($event)"
                ></emma-dropdown>
            </span>
        </div>
    </quill-editor>
</div>
